import {
  UserGroup,
  CarrierType,
  Shipping,
  getPatientLabelFirstLine,
} from "@jasper/shared";
import { Button, Text } from "@mantine/core";
import { IconSquareCheckFilled } from "@tabler/icons-react";
import { useEffect, useState } from "react";

export const UserGroupShipping = (props: {
  userGroup: UserGroup;
  downloadShippingLabel: () => Promise<Shipping[]>;
  isTodayDateSelected: boolean;
}) => {
  const { userGroup, downloadShippingLabel, isTodayDateSelected } = props;
  const [shippings, setShippings] = useState<Shipping[]>([]);

  useEffect(() => {
    setShippings(userGroup.shipping ?? []);
  }, [userGroup.id, JSON.stringify(userGroup.shipping)]);

  return (
    <>
      {userGroup.deliveryCarrier === CarrierType.FEDEX_TNT &&
        isTodayDateSelected && (
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={async () => {
                const updatedShippings = await downloadShippingLabel();
                if ((updatedShippings ?? []).length > 0) {
                  setShippings(updatedShippings);
                }
              }}
            >
              Download label
            </Button>
          </div>
        )}
      {shippings.map((shipping, index: number) => {
        return (
          <div key={shipping.id} style={{ paddingBottom: "2rem" }}>
            <Text>
              Shipping {index + 1}
              {shipping?.trackingNumber ? (
                <>
                  {`- Tracking number ${shipping.trackingNumber} `}
                  <IconSquareCheckFilled
                    style={{
                      verticalAlign: "text-bottom",
                      color: "#4CAF50",
                    }}
                  />
                </>
              ) : (
                ""
              )}{" "}
            </Text>
            <ul>
              {(shipping?.shippings ?? []).map(s => {
                return (
                  <li key={s.order.orderReference}>
                    {s.order.orderReference} -{" "}
                    {getPatientLabelFirstLine(s.order)}
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </>
  );
};
